export default __webpack_public_path__ + "static/media/game.04b717d5.png";